var entryId = bShare.addEntry({
    title: "《铁甲雄兵》张飞觉醒皮肤套装“阿修罗王”震撼发布。",
    summary: "张飞阿修罗军团新皮肤同期发布，更有主武器皮肤“大炎魔天”、副武器“婆娑罗”、背饰“他化自在天”震撼来袭。",
    pic: "http://bos.ycgame.com/act/1809lb/images/200x200.jpg",
});
$('.qq').on("click", function (e) {

    bShare.share(e, "qqim", entryId)
});
$('.wx').on("click", function (e) {
    bShare.share(e, "weixin", entryId)
});
$('.qzone').click(function (e) {
    bShare.share(e, "qzone", entryId)
});
$('.sina').click(function (e) {
    bShare.share(e, "sinaminiblog", entryId)
});
$('.baidu').click(function (e) {
    bShare.share(e, "itieba", entryId)
});


//////////////////
// WEBPACK FOOTER
// ./share.js
// module id = 2
// module chunks = 0